import  { useEffect, useState, useRef, useContext } from "react";
import React from "react";
import Loader from "./Loader";
import defaultBlogImage from "../defaultBlog.jpg";
import axios from "axios";
import { json, useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { handleShare, SearchOnDesktop } from "./HandleShare";
import { BlogAudioContext } from "./BlogAudioContext";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Alert from "./Alert";
import {Helmet} from "react-helmet"
import ImageDialog from "./ImageDialog";
import Tooltip from "./Tooltip";
import { getImageColors } from "./GetImageColors";
import "./BlogDetail.css"
import AppShareer from "./AppShareer";
import  {ShareOnDesktop}  from "./HandleShare";
import {getCollectionTitle, timeForPage, trackEvent, trackImages, vibrateMobileDevice} from "./UtilsFunction"
import { saveMessages } from "./savedMessage";
import { toImageKitURL } from "./UtilsFunction";
import { GetCaptionForImages } from "./GetCaptionForImages";

import { ShowEndImageSection } from "./ShowEndImageSection";
import { marked } from "marked";
import Blogs from "./Blogs";


let blogTitile = "";
// let droppedSrc = ""
const categorySubtitles = {
  artistic: "Handpicked creative images",
  mountain: "Nature’s calmest mountain views",
  sunset: "Soft moments wrapped in color",
  travel: "Places that inspire your next journey",
  sky: "Where calm skies find you",
  car: "Handpicked automotive aesthetics",
  home: "Handpicked home inspirations"
};


function BlogBack(props) {
  const { isPlaying, isPaused, setIsPaused ,playBlog,  samePage } = useContext(BlogAudioContext);
  const [heading, setHeading] = useState("");
  const [imageSrcForExploreNext, setImageSrcForExploreNext] = useState("");
  const[imagePreviewURLForHeader, setImagePreviewURLForHeader] = useState("")       //updated new
  const [downloadedPixabayUrl, setDowonloadPixabayUrl] = useState(null)
  const [clickImageObject, setClickImageObject] = useState("")
  const navigate = useNavigate();
  // const utterance = useRef(null); 
  const playIcon = useRef(null);
  const shareIcon = useRef(null);
  const [readBlogs, setReadBlogs] = useState(isPlaying);
  const params = useParams()
  const [imageHeader, setImagesHeader] = useState(false)         // to track the image header type like image/blogdetail
  const location = useLocation()
  const [droppedImageSize , setDropperImageSize] = useState({})
  const [userCommingFrom, setUserCommingFrom ] = useState(true)     // comming from website or other platefroms if false it mean comming from others
  const [imageColor, setImageColor] = useState("#ffff")
  const [headerImageLoaded, setHeaderImageLoaded] = useState(false);
  const showSavedHintRef = useRef(null);
  const topRef = useRef(null);
  
const [showHeaderImage, setShowHeaderImage] = useState(true);
const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);



useEffect(() => {


  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        // User at TOP
        setShowHeaderImage(false);
        
      } else {
        // User scrolled
        setShowHeaderImage(true);
        
      }
    },
    {
      root: null,
      threshold: 0,
    }
  );

  if (topRef.current) {
  

    observer.observe(topRef.current);
    
    
  }

  return () => {
    if (topRef.current) observer.unobserve(topRef.current);
    
    
  };


}, []);


// useEffect(() => {
//   setHeaderImageLoaded(false);
// }, [imageSrcForExploreNext]);



//   useEffect(()=>{
// console.log("imageLoad imageSrc", imageSrcForExploreNext)
//   }, [imageSrcForExploreNext])


  


const pageType = props.componentFrom?.page;
const blogTitleParam = props.componentFrom?.blogTitle;
const [caption, setCaption] = useState(null)

function makewebformatImageUrl(image){

  console.log("previewURL for...", image.previewURL);

  return image?._source !== "pexels" ? image.previewURL.replace("_150.jpg", "_640.jpg") : image.previewURL

}

function makelargeImageUrl(image){

  return image?._source !== "pexels" ? image.previewURL.replace("_150.jpg", "_1280.jpg") : image.previewURL

}


useEffect(() => {
  // ===============================
  // EXPLORE NEXT HEADER
  // ===============================
  if (pageType === "explore-next") {
    setImagesHeader(true);

    // let title = props.componentFrom.imageTag.split(/[-\s]+/)[0]?.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) || "Explore";
    // title = title + " " + "Inspirations"

    let title = getCollectionTitle(props.componentFrom.imageTag)
const imageData = location.state?.imageData;

    setHeading(title);
    // setHeading((imageData.heading).replace("photo", "Inspirations") || title);
    setHeaderImageLoaded(false);

    // const imageData = location.state?.imageData;

    if (imageData) {
      setUserCommingFrom(true);
      // let imageKitSrc =  toImageKitURL(imageData.webformatURL, 100)
      let imageKitSrc = makewebformatImageUrl(imageData)
      let imagePreviewURL = imageData.previewURL      //new added
      setImagePreviewURLForHeader(imagePreviewURL)
      console.log("imageData for backheader", imageKitSrc, imageData)
      setImageSrcForExploreNext(imageKitSrc);
      setDowonloadPixabayUrl(makelargeImageUrl(imageData));
      setCaption(GetCaptionForImages(imageData))
      setClickImageObject(imageData);
    
    } else {
      setUserCommingFrom(false);
      setImageSrcForExploreNext("");
    }

    return;
  }

  // ===============================
  // BLOG DETAIL HEADER ✅ FIX
  // ===============================
  if (pageType === "blog-detail") {
    setImagesHeader(false);
    setUserCommingFrom(true);

    if (blogTitleParam) {
      const cleanTitle = decodeURIComponent(blogTitleParam).replace(/-/g, " ");
      setHeading(
        cleanTitle.charAt(0).toUpperCase() + cleanTitle.slice(1)
      );
    }

    return;
  }
}, [
  pageType,
  blogTitleParam,
  props.componentFrom?.imageTag,
  location.state,
]);


  
//   function handleBack(event) {
//     removeClickFeed(event)
//     vibrateMobileDevice()

//     setTimeout(()=>{
// if(!userCommingFrom){
//   navigate("/explore");
//   return
// }else{
//   navigate(-1)
  
// }

// if(imageHeader){
//    navigate("/explore");
//    return
// }else{
//   navigate("/blogs")
// }

      
  
//     }, 100)
   
//   }

function handleBack(event) {
  removeClickFeed(event);
  vibrateMobileDevice();
  trackEvent("back_button_click", {
    from: `${timeForPage()}-${window.location.pathname}`
  })

  setTimeout(() => {
    // If user came from inside the app, respect history
    if (userCommingFrom) {
      navigate(-1);
      return;
    }

    // External / direct entry
    if (props.componentFrom?.page === "blog-detail") {
      navigate("/blogs");
      return;
    }

    navigate("/explore");
  }, 100);
}





const searchModalRef = useRef(null);
const openSearchModel = useRef(false)
const searchInputRef = useRef(null)
  function shareBlogs(event, forWhich) {
    let pageTitle , pageUrl;
    // console.log("share on forWhich", forWhich)
   if(forWhich === "share"){
    console.log("click on share")
    if(imageHeader){
//  const imageData = location.state?.imageData
      pageTitle = document.querySelector("#exploreTagImage").innerText    
      //  pageUrl = imageData.webformatURL
       pageUrl = imageSrcForExploreNext
       trackImages("share_image_from_backheader", pageUrl)

    }else{

       pageTitle = document.querySelector("#blogDtailTitle").innerText    
       pageUrl = document.getElementById('blogTopImage').src
       trackImages("share_blog_from_backheader", pageUrl)

    }
    console.log("share on explore next page", pageTitle, pageUrl)
    handleShare(pageTitle, "", pageUrl, "blogDetail", window.location.url, shareIcon.current)
    // console.log("event", event, imageUrl, blogTitle);
  }else{
    console.log("click on search")
openSearchModel.current = true
  const imageTopic = props?.componentFrom?.imageTag?.replace(/-/g, " ").replace(/\b\w/g, (c) => c.toUpperCase());

  trackEvent("search_icon_click", {
    page: props?.componentFrom?.page || "exploreNext",
    searchIconClickTopic: imageTopic || heading || "unknown"
  });

    setTimeout(()=>{

          searchModalRef.current.classList.add("show");
    searchModalRef.current.firstElementChild.classList.add("full-width");

   setTimeout(()=>{
    searchInputRef.current?.focus();
   }, 50)

    
    }, 100)

  }
  }

  function readBlog() {
    // console.log("set blogs")
    const textElement = document.getElementById("textToSpeak");
    let blogId = document.getElementById("blogIdDetails").innerText
    console.log("textElement", blogId);
  playBlog(blogId ,heading, textElement)


  }
  function sendClickFeed(event){    
    let shareButton = event.target;
    if(shareButton){
      shareButton.style.backgroundColor = "white";
      shareButton.style.color = "black";
      
   
    }
    
  }
  function removeClickFeed(event){    
    let shareButton = event.target;
    if(shareButton){
      shareButton.style.backgroundColor = "white";
      shareButton.style.color = "";     
      orignalElement(event)
    }
    
  }
  function orignalElement(event){
    let shareButton = event?.target;
    if(shareButton){
      shareButton.style.backgroundColor = "#eee";
      shareButton.style.color = "";         
    }    
  }

  


  useEffect(() => {
  if(isPaused){
    setReadBlogs(true)
  }else{
    setReadBlogs(false)

  }
  
  }, [isPaused]);
  function animateIcon(navbarIcon){
    navbarIcon.style.setProperty('font-size', "13px")
    setTimeout(()=>{
      navbarIcon.style.removeProperty('font-size', "14px") 

    }, 100)
  }

  useEffect(() => {
   if(!isPlaying){
    setReadBlogs(false)
  }  
  }, [isPlaying]);

function buttonEnable(element, type){
  const playButton = element
if(playButton){
  // console.log("playButton", playButton)
  playButton.disabled = type
}
}
  useEffect(()=>{
    if(isPlaying){  
      // when user navigate the pages
      if(samePage){
        // console.log("enable true", samePage)
        buttonEnable(playIcon.current, false)
      }else{
       buttonEnable(playIcon.current, true)
        // console.log("enable false", samePage)
        }
    } 
    // when user stop the blog playing
    if(!isPlaying){
      buttonEnable(playIcon.current, false)
    }
  }, [samePage, isPlaying])

  // function downlodImage(event, imageUrl) {
  //     // Extract extension from the image URL
  //     console.log("download clicked image ", imageUrl, "huu")
  //     if(!imageUrl) return
  //      // Create a hidden download link
      
      

  // const urlParts = imageUrl.split(".");
  // console.log("imageurl", imageUrl)
  // const extension = urlParts[urlParts.length - 1].split("?")[0]; 
  

  //  const img = new Image();
  // img.crossOrigin = "anonymous"; // try CORS
  // img.src = imageUrl;

  // img.onload = () => {
  //   const canvas = document.createElement("canvas");
  //   canvas.width = img.width;
  //   canvas.height = img.height;
  //   const ctx = canvas.getContext("2d");
  //   ctx.drawImage(img, 0, 0);
  //   canvas.toBlob((blob) => {
  //     const url = URL.createObjectURL(blob);
  //     const link = document.createElement("a");
  //     link.href = url;
  //     link.download = heading + `.${extension}`;
  //     link.click();
  //     URL.revokeObjectURL(url);
  //     // toast.success("Image download successful.");
  //     toast.success("Image downloaded");
  //   });
  // };

  // img.onerror = () => {
  //   toast.error("Sorry... image could'nt downloaded now... try again later");
  // };
  // }

   function downlodImage(event , imageUrl) {
      // Extract extension from the image URL
      // console.log("download clicked image ", imageUrl, "huu")
      if(!imageUrl) return    

try{


    const downloadImageUrl = imageUrl;
  const fileName = `BrowseNext-${heading || "image"}`;


  // const downloadUrl = `http://localhost:3001/api/download?url=${encodeURIComponent(downloadImageUrl)}&name=${encodeURIComponent(fileName)}`;

  const downloadUrl = `/api/download?url=${encodeURIComponent(downloadImageUrl)}&name=${encodeURIComponent(fileName)}`;

  
    const link = document.createElement("a");
    link.href = downloadUrl;   
      // link.rel = "noopener"; 
    link.click();
   trackImages("download_image_from_backheader", imageUrl)
    

  toast.success("Image downloaded");
}catch(error){
  trackImages("download_imagefailed_from_backheader", imageUrl)
    toast.error("Image could'nt downloaded now... try again later");
  

}
  }

  function SeeMoreDetails(event, clickedImage){
    console.log("see More Details", clickedImage)
  }
  
//   function openViewImage() {
//     let imageDialog = document.getElementById("imageDialog");
//     let imageWrapper = document.getElementById("imageWrapper");
//     let img = imageWrapper.querySelector("img");

//     if (imageDialog && img) {
//         // imageDialog.style.opacity = "1";
//         // imageDialog.style.zIndex = "9999";
//         imageDialog.classList.add('open_main_image_dialog')
//         imageWrapper.classList.add('open_image_wrapper')
     
        

        

       
//         // imageWrapper.style.width = `${imageSrcForExploreNext.webformatWidth}px`
//         // imageWrapper.style.height = `${imageSrcForExploreNext.webformatHeight}px`
//         if(window.innerWidth <= 480 && window.innerHeight < clickImageObject.webformatHeight){
//               imageWrapper.style.setProperty("width", `${clickImageObject.webformatWidth || droppedImageSize?.width}px`, "important" )
//           imageWrapper.style.setProperty("height", `${400 || 400}px`,  "important")
//           // imageWrapper.style.setProperty("border-radius", `50px`,  "important")
//           // img.style.setProperty("border-radius", `50px`,  "important")
          
//           // console.log("image height is grater then window height", )

//         }else{

//           imageWrapper.style.setProperty("width", `${clickImageObject.webformatWidth || droppedImageSize?.width}px`, "important" )
//           imageWrapper.style.setProperty("height", `${clickImageObject.webformatHeight || droppedImageSize?.height}px`,  "important")
//         }

        

       
//     }
// }

const [openBDImage, setBDImage] = useState(false)
function openViewImage() {
  setBDImage(true)
  trackImages("open_big_image_from_backheader")
setTimeout(()=>{
  const imageDialog = document.getElementById("imageDialog");
  const imageWrapper = document.getElementById("imageWrapper");
  const img = imageWrapper.querySelector("img");

  if (!imageDialog || !img) return;

  // Defer UI activation until image is decoded
  img.decode().then(() => {
    requestAnimationFrame(() => {
      imageDialog.classList.add('open_main_image_dialog');
      imageWrapper.classList.add('open_image_wrapper');

      const width = clickImageObject.webformatWidth || droppedImageSize?.width;
      const height = clickImageObject.webformatHeight || droppedImageSize?.height;

      if (window.innerWidth <= 480 && window.innerHeight < height) {
        imageWrapper.style.setProperty("width", `${width}px`, "important");
        imageWrapper.style.setProperty("height", `400px`, "important");
      } else {
        imageWrapper.style.setProperty("width", `${width}px`, "important");
        imageWrapper.style.setProperty("height", `${height}px`, "important");
      }
    });

  }).catch(() => {
    // fallback if image decode fails
    imageDialog.classList.add('open_main_image_dialog');
    imageWrapper.classList.add('open_image_wrapper');
  });
}, 100)

}

const [isSavedOnHeader, setIsSavedOnHeader] = useState(false);

useEffect(() => {
  if (!clickImageObject) return;

  const savedImages = JSON.parse(localStorage.getItem("savedImages")) || [];
  const already = savedImages.some(img => img.id === clickImageObject.id);

  setIsSavedOnHeader(already);
}, [clickImageObject]);

function saveImage(event, clickedImageObj){
  console.log("save image function on blog header", clickedImageObj)
   if (!clickedImageObj) return;

  try {
    let savedImages = JSON.parse(localStorage.getItem("savedImages")) || [];
    
    const alreadySaved = savedImages.some(
      img => img.id === clickedImageObj.id
    );

    if (!alreadySaved) {
      savedImages.push(clickedImageObj);
      localStorage.setItem("savedImages", JSON.stringify(savedImages));
      // toast.success("Image saved");
      showToast()
      showNewBadgeInSavedImage(clickImageObject)
      setIsSavedOnHeader(true)
      trackImages("save_image_from_backheader", clickedImageObj.previewURL)
    } else {
      toast.info("Image already saved");
      setIsSavedOnHeader(true)
    }
  } catch (error) {
    trackImages("failed_save_error_from_backheader", clickedImageObj.previewURL)
    console.error("Error saving image:", error);
    setIsSavedOnHeader(false)
  }

}
function showToast(){
        let savedImages = JSON.parse(localStorage.getItem("savedImages")) || [];
      let savedProductLength = savedImages.length;
       if(savedProductLength === 0){
          toast.success("Image saved — You have great taste 🔥");
          
        }else{
           const randomMessage = saveMessages[Math.floor(Math.random() * saveMessages.length)];
      toast.success(`Image saved — ${randomMessage}`);
  
        }
  
}

function showNewBadgeInSavedImage(clickedImageObj){
  let newBadgeIds = JSON.parse(localStorage.getItem("savedNewBadges")) || [];
        if (!newBadgeIds.includes(clickedImageObj.id)) {
          console.log("saved id from saved function", clickedImageObj.id)
          newBadgeIds.push(clickedImageObj.id);
          // newBadgeIds.push("772991");
        }
        localStorage.setItem("savedNewBadges", JSON.stringify(newBadgeIds));

        console.log("Added NEW badge for image:", clickedImageObj.id);

}

// const integerPart = Math.floor(Math.random() * 50 + 10);
// const decimalPart = Math.floor(Math.random() * 9) + 1; 
// const Searchedvalue = `${integerPart}.${decimalPart}`;

const [Searchedvalue, setSearchedValue] = useState(null)

useEffect(() => {
  const integerPart = Math.floor(Math.random() * 50 + 10);
  const decimalPart = Math.floor(Math.random() * 9) + 1;
  setSearchedValue(`${integerPart}.${decimalPart}`);
}, [props.displayImage]);

    
      if (showSavedHintRef.current === null) {
  showSavedHintRef.current = shouldShowSavedHint();
}

function shouldShowSavedHint() {
  // show at most once per session
  if (sessionStorage.getItem("shownSavedExploreHint")) return false;

  sessionStorage.setItem("shownSavedExploreHint", "true");
  return true;
}

  return (
    <>
    {/* <Alert position="bottom-center"> </Alert> */}
      <div className="back_header fixed-top">
        <div className={`container  app_blog_back_header app_container ${imageHeader ? 'max-width-full padding_left' : ''}`}>
          <div className="row d-flex align-items-center p-0 app_blog_detail_row ">
            {/* <div className="col-8 d-flex align-items-center app_blog_detail_action_first"> */}
            <div className={`${userCommingFrom ? 'col-8': 'col-9' }  d-flex align-items-center app_blog_detail_action_first`}>
            {/* onClick={handleBack} */}
            {/* <Tooltip text={`${(imageHeader) ? 'Back to explore' : 'Back to blog'}`} position="bottom"> */}
              <button
                className="fa-solid fa-arrow-left app_blog_detail_icon app_blog_detail_back_icon"  onClick={(event)=>{handleBack(event)}}
                 onTouchStart={sendClickFeed}
                  
                   onTouchEnd={(event)=>{
                   
                  removeClickFeed(event)}} onMouseUp={(event)=>{removeClickFeed(event)}} onMouseDown={sendClickFeed} onMouseOut={orignalElement}
              ></button>
            {/* </Tooltip> */}
           {imageHeader && imageSrcForExploreNext && imageSrcForExploreNext !== "" && showHeaderImage && (
  <>
  {console.log("src set", imageSrcForExploreNext)}
    {window.innerWidth > 768 ? ( // Desktop only
      <Tooltip text="Click to Expand image" position="bottom">
        <div
          className="relative image_backview_container"
          style={{ background: imageColor }}
          // onClick={openViewImage}
           onClick={()=>{
          if(!headerImageLoaded){
            return
          }
          openViewImage()
        }}
        >

          <img
            // src={imageSrcForExploreNext}
            src={imagePreviewURLForHeader}
            alt={`${heading}'s Photos`} 
            // className="back_header_image"
            className={`back_header_image ${headerImageLoaded ? "loaded" : ""}`}
            
             onLoad={() => setHeaderImageLoaded(true)}
          
          />
          
        {!headerImageLoaded && (
          <div className="skeletones" id="skeletonDesktop"></div>
        )}
        </div>
      </Tooltip>
    ) : ( 
      <div
        className="relative image_backview_container"
        style={{ background: imageColor }}
        onClick={()=>{
          if(!headerImageLoaded){
            return
          }
          openViewImage()
        }}
      >
        <img
          // src={imageSrcForExploreNext}
          src={imagePreviewURLForHeader}
          alt={`${heading}'s Photos`} 
          // className="back_header_image"
          className={`back_header_image ${headerImageLoaded ? "loaded" : ""}`}
          onLoad={() => setHeaderImageLoaded(true)}
             fetchPriority="high"
        />

        {!headerImageLoaded && (
          <div className="skeletones" id="skeletonMobile"></div>
        )}
      </div>
    )}
  </>
)}





{(imageHeader) ? (
  <>
  <div className="image_backheader_text image_heading_backheader">
  <span className="image_heading_backheader" id="exploreTagImage"> {heading} 
  {/* {`${imageHeader && imageSrcForExploreNext && imageSrcForExploreNext !== "" ? "" : " Inspiration"}`} */}
   </span>  

  {/* <span class="last_updated_text">{categorySubtitles[heading.toLowerCase()] || "Explore similar images"}</span> */}

    {/* <span className="last_updated_text app_three_dots"> app_three_dots */}

  {caption ? <>
    <span className={userCommingFrom ? `last_updated_text app_three_dots alignment_text` : `last_updated_text alignment_text`} > 
      <i class="fa-solid fa-wand-magic-sparkles"></i> {caption}
    </span>
  </> : showSavedHintRef.current ? (
    <span className={userCommingFrom ? `last_updated_text app_three_dots` : `last_updated_text`} > 
      {/* More users saved from past 7 days */}
      {/* {`Searched by ${Searchedvalue}k people`} */}
      {`${Searchedvalue}k people explored this on BrowseNext`}
    </span>
  ) : (
    <span className={userCommingFrom ? `last_updated_text app_three_dots` : `last_updated_text`}>
      {categorySubtitles[heading.toLowerCase()]}
    </span>
  )}
  {/* caption */}


  </div>
  </>
)
: 
(
  <>
<span className="blog_back_heading" id="exploreTagImage"> {heading} </span>  

  </>
)

}
              {/* <span className="blog_back_heading " id="exploreTagImage"> {heading} </span> */}
              
            </div>
            {/* <div className="col-4 d-flex align-items-center justify-content-end app_blog_detail_action_secound" > */}
            <div className={`${userCommingFrom ? 'col-4': 'col-3'}  d-flex align-items-center justify-content-end app_blog_detail_action_secound`} >
            {/* blog speak button */}
            {(!imageHeader) ?                 
             
               <button
               ref={playIcon}
                className={`${
                 readBlogs ? "fa-solid fa-pause" : "fa-solid fa-play"
                } app_blog_detail_icon`}
                type="button"
                id="AppPlayIcon"
                style={{ padding: readBlogs ? "10px 13px" : "10px 12px"  }}
                onClick={(e) => {
                  const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

                    trackEvent("blog_play_click", {    
    topicAndPage: document.getElementById("blogIdDetails")?.innerText || heading,
    from: window.location.pathname,
    deviceWidth: isMobile ? "mobile" : "desktop"
  });

                  if(isMobile){
                    animateIcon(playIcon.current)                  
                    setReadBlogs(false)
                    toast.info("Switch on the desktop to enjoy this feature")
                    // console.log("mobile devices", readBlogs, isPlaying)
                    return
                  }
                  
                setReadBlogs((prev) => {
  if (prev) {
    // ✅ If currently reading → pause it
    window.speechSynthesis.pause();
    setIsPaused(false);
  } else {
    // ▶️ If paused → resume speech, else start reading new blog
    if (window.speechSynthesis.paused) {
      window.speechSynthesis.resume();
      setIsPaused(true);
    } else {
      readBlog(); // your function that starts a new utterance
      setIsPaused(true);
    }
  }

  return !prev;
})
                  
                }}
              ></button>
              :
              <>
               {/* (
  window.innerWidth > 999 && (
    <button className="app_blog_detail_icon download_icon_button" onClick={(e) =>{downlodImage(e, imageSrcForExploreNext?.largeImageURL)}}>
      <i className="fa-solid fa-download"></i>
    </button>
  )
) */}

  {/* <button className="app_blog_detail_icon download_icon_button" style={{padding:" 8px 13px"}} onClick={(e) =>{SeeMoreDetails(e, clickImageObject)}}>
      
      <i class="fa-solid fa-angle-right"></i>
    </button> */}
    {userCommingFrom && 

    <>
    <Tooltip text="Save" position="bottom">
      <button className="app_blog_detail_icon download_icon_button save_image_backheader" onClick={(e) =>{saveImage(e, clickImageObject)}}>
      
      <i className={isSavedOnHeader ? "fa-solid fa-bookmark save_icon_font" : "fa-regular fa-bookmark save_icon_font"}></i>
    </button>
      
    
    </Tooltip>

         <Tooltip text="Download" position="bottom">
      <button className="app_blog_detail_icon download_icon_button" onClick={(e) =>{downlodImage(e, imageSrcForExploreNext)}}>
      <i className="fa-solid fa-download"></i>
    </button>

        
    </Tooltip>

       {/* {caption ? <>

        <Tooltip text="Caption & Hashtags" position="bottom">
      <button className="app_blog_detail_icon download_icon_button" onClick={(e) =>{
      //  const captionText =  GetCaptionForImages(clickImageObject)
         navigate("/tools", {
        state: { captionText: caption }
      });
      
      }}>
      
      <i class="fa-solid fa-wand-magic-sparkles"></i>
    
    </button>

        
    </Tooltip>

    </>: <>

 
    </>} */}
    
 
    </>
    
    }

    </>          
             
              
            }
            {/* blog speak button End here */}
            {!userCommingFrom && imageHeader && !isMobile && (<>
              <Tooltip text="Search" position="bottom">
              <button
              // ref={shareIcon}
                className="fa-solid fa-magnifying-glass app_blog_detail_icon new_share_bh"
                onClick={(e) =>{
                console.log("share on ")             
                shareBlogs(e, "search")
                }
                }
                
              ></button>
              </Tooltip>

            </>)}
              



            <Tooltip text="Share" position="bottom">
              <button
              ref={shareIcon}
                className="fa-solid fa-share-nodes app_blog_detail_icon new_share_bh"
                onClick={(e) =>                 
                shareBlogs(e, "share")
                }
                
              ></button>
              </Tooltip>
            </div>
          </div>
        </div>
      </div>
      {openBDImage &&(

      <ImageDialog imageUrl={imageSrcForExploreNext} heading={heading} openImage={setBDImage} />

      )

      
      
      }
      {!imageHeader && 
      <ShareOnDesktop imageUrl={imageSrcForExploreNext} title={`Take a look for  ${heading} ${imageHeader ? 'images' : 'blogs'} on BrowseNext`} imageName={heading} 
      shareType={imageHeader ? 'images' : 'blogs'}
       />    
      
      }

      {openSearchModel && 
      <SearchOnDesktop 
        searchModalRef={searchModalRef}
        searchInputRef={searchInputRef}

       />    
      
      }

      <div ref={topRef} style={{ height: "1px" }} />
    </>
  );
}
const BlogDetail = (props) => {
  // console.log("blog Details Page");

  const [loader, setloader] = useState(true);
  const [blogDetail, setBlogDetail] = useState([]);
  const blogId = useParams();

  function getBlogDetails() {
    let getBlogUrl = `https://dev.to/api/articles/${blogId.blogId}`;
    axios.get(getBlogUrl).then((bDetails) => {
      setloader(false);
      // setBlogDetail(bDetails.data);
      setBlogDetail([bDetails.data]);
      // blogDetail.push(bDetails.data);
      // blogTitile = blogDetail[0].title;
      blogTitile = bDetails.data.title ;
      
      console.log("blog Details response", bDetails.data.title);
      setTimeout(() => {
        // setStyleCode();
        // convertParagraphCodeBlocks()

           convertParagraphCodeBlocks();

    requestAnimationFrame(() => {
        setStyleCode();
    });
      }, 1000);
    });
  }


function looksLikeCode(text) {
  const t = text.trim();

  return (
    t.startsWith("const ") ||
    t.startsWith("let ") ||
    t.startsWith("var ") ||
    t.startsWith("function ") ||
    t.startsWith("if ") ||
    t.startsWith("for ") ||
    t.startsWith("while ") ||
    t.startsWith("return ") ||
    t.startsWith("class ") ||
    t.startsWith("import ") ||
    t.startsWith("export ") ||
    t.startsWith("//") ||
    t.startsWith("/*") ||
    t.startsWith("*") ||
    t.includes("{") ||
    t.includes("}") ||
    t.includes("=>") ||
    t.includes(";")
  );
}

function convertParagraphCodeBlocks() {
  const container = document.querySelector("#textToSpeak");
  if (!container) return;

  const paragraphs = [...container.querySelectorAll("p")];

  const languages = [
    "javascript",
    "python",
    "java",
    "html",
    "css",
    "typescript",
    "php",
    "bash",
    "json",
  ];

  for (let i = 0; i < paragraphs.length; i++) {

    const language = paragraphs[i].textContent.trim().toLowerCase();

    // This paragraph must contain only the language name
    if (!languages.includes(language)) {
      continue;
    }

    let code = [];
    let j = i + 1;

    while (j < paragraphs.length) {

      const nextText = paragraphs[j].textContent.trim();

      // Stop at empty line
      if (!nextText) break;

      // Stop if next language starts
      if (languages.includes(nextText.toLowerCase())) break;

      // Stop if heading like "2. Something"
      if (/^\d+\./.test(nextText)) break;

      // Stop if normal English paragraph starts
      if (!looksLikeCode(nextText)) break;

      code.push(nextText);

      paragraphs[j].remove();
      j++;
    }

    if (!code.length) continue;

    const pre = document.createElement("pre");
    pre.className = `language-${language}`;

    const codeTag = document.createElement("code");
    codeTag.className = `language-${language}`;
    codeTag.textContent = code.join("\n");

    pre.appendChild(codeTag);

    paragraphs[i].replaceWith(pre);
  }
}

function setStyleCode() {
  if (!window.Prism) return;

  const codeBlocks = document.querySelectorAll("#textToSpeak pre code");

  codeBlocks.forEach((code) => {
    const pre = code.parentElement;

    // Enable line numbers
    

    // Highlight
    window.Prism.highlightElement(code);
    




    // Prevent duplicate toolbar
    if (pre.querySelector(".code-toolbar")) return;

    pre.style.position = "relative";
    // pre.style.overflowX = "auto"
   pre.style.overflow = "hidden";

code.style.whiteSpace = "pre";


 const scrollWrapper = document.createElement("div");
    scrollWrapper.className = "code-scroll";

    scrollWrapper.style.overflowX = "auto";
    scrollWrapper.style.maxWidth = "100%";

    // Put existing <code> inside wrapper
    pre.insertBefore(scrollWrapper, code);
    scrollWrapper.appendChild(code);

    const language =
      [...code.classList]
        .find(cls => cls.startsWith("language-"))
        ?.replace("language-", "") || "text";

    const formattedLanguage =
      language.charAt(0).toUpperCase() + language.slice(1);

    const toolbar = document.createElement("div");
    toolbar.className = "code-toolbar";

    const languageLabel = document.createElement("span");
    languageLabel.className = "code-language";
    languageLabel.innerText = formattedLanguage;

    const button = document.createElement("button");
    button.className = "copy-code-btn";
    button.innerHTML = '<i class="fa-regular fa-copy"></i> Copy';

    button.onclick = async () => {
      try {
        await navigator.clipboard.writeText(code.textContent);

        button.innerHTML = '<i class="fa-solid fa-check"></i> Copied';

        setTimeout(() => {
          button.innerHTML = '<i class="fa-regular fa-copy"></i> Copy';
        }, 1500);
      } catch (err) {
        console.error(err);
      }
    };

    toolbar.appendChild(languageLabel);
    toolbar.appendChild(button);

    // pre.insertBefore(toolbar, code);
        pre.insertBefore(toolbar, scrollWrapper);
        

   
  });
}
  // useEffect(() => {
  //   getBlogDetails();
  // }, []);


  useEffect(() => {
  // setloader(true);
  // setBlogDetail([]);
  getBlogDetails();
}, [blogId.blogId]);




  if (loader === true) {
    return (
      <>
        <Loader></Loader>
      </>
    );
  } else {
    return (
      <>
         <Helmet>
      <title>
        {blogTitile}
      </title>
      <meta name="description" content="" />
      <meta name="keywords" content="" />

       <meta property="og:title" content={blogTitile} />
  <meta property="og:description" content="" />
  <meta property="og:type" content="website" />
  {/* <meta property="og:url" content="https://browsenext.today/blogs" /> */}
  <meta property="og:image" content="https://browsenext.today/favicons.png" />
  {/* <link rel="canonical" href="https://browsenext.today/blogs" /> */}
    </Helmet>
    {/* mt-74 */}
        <div className="app_detail_blog_container container  app_container ">
          <div className="row p-0 w-100 d-flex align-items-center overflow-hidden flex-row-reverse position-relative">
            {/* blog user action  end Here*/}
            {/* blog details appear starts Here*/}
            <div className="col-10 blog_user_action w-100 blog_detail_full_content">
              <div className={`blog_content_top_img w-100 ${blogDetail[0].cover_image && blogDetail[0].cover_image.length > 0 ? '' : 'set_height_small'}`}>
                <img
                
className={` img-fluid blog_detail_top_image w-100 ${blogDetail[0].cover_image && blogDetail[0].cover_image.length > 0 ? '' : 'no_blog_image'}`}
                  src={
                    blogDetail[0].cover_image &&
                    blogDetail[0].cover_image.length > 0
                      ? blogDetail[0].cover_image
                      : defaultBlogImage
                  }
                  // className="img-fluid blog_detail_top_image w-100"
                  height="500px"
                  id="blogTopImage"
                  alt=""
                />
                {/* <div className="position-absolute d-flex align-items-center justify-content-between blog_detail_header_icon">            
            <i class="fa-solid fa-circle-play" onClick={readBlog}></i>
            </div> */}
              </div>
               <h1
                style={{
                  fontSize: "25px",
                  fontWeight: "700",
                  display: "none",
                  lineHeight: "30px",
                }}
                className="blog_title text_left"
                id="blogDtailTitle"
                
              >
                {" "}
                {blogDetail[0].title}
              </h1> 
<span style={{display: "none"}} id="blogIdDetails"> {blogDetail[0].id}</span>
              <div id="textToSpeak" style={{marginTop: "-10px"}}>
                <span
                  className="gallerytitle productname productdiscripation blog_detail_content_img"
                  dangerouslySetInnerHTML={{
                    __html: marked(blogDetail[0].body_markdown),
                    
                  }}
                />
                <span
                  className="gallerytitle productname productdiscripation blog_detail_content_img"
                  dangerouslySetInnerHTML={{ __html: marked(blogDetail[0].body_html) }}
                  
                />
                <span
                  className="gallerytitle productname productdiscripation blog_detail_content_img"
                  dangerouslySetInnerHTML={{
                    __html: blogDetail[0].descripation,
                  }}
                />
              </div>
            </div>
            {/* blog details appear starts Here*/}

            {/* blog details appear starts Here*/}
            {/* <div className="col-2 app_advertise_content">
            here the blog heading keys

            </div> */}
            
            

            
          </div>
        </div>

<div className={`app_container container blog_explore_section p-0 ${props.componentFrom !== "blog-detail" ? 'text-to-bold-container' :''} ${props.componentFrom === "exploreNext" ? 'small_padding_for_explorenext_desktop max-width-full' : ''}`}>
<div className="blog_detail_divider"></div>
<div className="explore_blog_heading d-flex justify-content-between align-items-center highlight_explore_images_heading">
<h2 className="app_home_feeds_heading  m-0 mb-0">Related Blogs </h2>
{/* <Link className="app_explore_see_all cursor-pointer"
          
         
           to={"/blogs"}
           draggable={false} 
           
          
          >
        
          See all blogs
<i className="fa-solid fa-angle-right home_seeall_icon"></i>
          </Link> */}
          </div>
         <Blogs componentFrom="home" />

          <Link className="brand_button image_ending_section blog_show_all_end "
  
           to={"/blogs"}
           draggable={false} 
             onClick={() => {
    trackEvent("show_allblog_click_link", {
      from: window.location.pathname,
      
      topicAndPage: blogTitile
    });
  }}

     style={{width: "fit-content", padding: "10px 30px 14px 30px", cursor: "pointer", borderRadius: "10px", fontWeight: 600,
      pointerEvents: "auto",
     }}> See more related blogs<i className="fa-solid fa-angles-right icon_space"></i></Link>
         
         </div>
        
          <ShowEndImageSection fetchSavedImages={props.fetchSavedImages} componentFrom="blog-detail" />
        {/* </div> */}

      </>
    );
  }
};

export { BlogDetail, BlogBack }

